import { HStack, Text, Button, Checkbox } from '@chakra-ui/react';
import { FiCheck, FiZap, FiArrowRight, FiRotateCcw, FiSave } from 'react-icons/fi'

type ModalMode = 'view' | 'auto-preview' | 'loading' | 'recut-dialog'

interface Props {
  mode: ModalMode
  isDirty: boolean
  isLastStep: boolean
  isSaving: boolean
  isStaticMode: boolean
  forwardToItinerary: boolean
  onForwardToItineraryChange: (val: boolean) => void
  targetDateLabel: string
  onAutoRecutDialog: () => void
  onRevert: () => void
  onSaveUpdatedTurfs: () => void
  onAcceptAsIs: () => void
  onAcceptRecut: () => void
}

export function TurfReviewActionBar({
  mode, isDirty, isLastStep, isSaving, isStaticMode,
  forwardToItinerary, onForwardToItineraryChange, targetDateLabel,
  onAutoRecutDialog, onRevert, onSaveUpdatedTurfs, onAcceptAsIs, onAcceptRecut,
}: Props) {
  return (
    <HStack gap={3} justify="space-between" flexWrap="wrap">
      <Checkbox.Root
        size="sm"
        onCheckedChange={(e) => onForwardToItineraryChange(e.checked === true)}
        checked={forwardToItinerary}
      ><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label>
        <Text fontSize="sm">
          {isStaticMode
            ? 'Update turf assignments'
            : `Push to itinerary (${targetDateLabel})`}
        </Text>
      </Checkbox.Label></Checkbox.Root>

      <HStack gap={3}>
        {mode === 'view' && (
          <>
            {isDirty && (
              <Button size="sm" variant="outline" onClick={onRevert}><FiRotateCcw />Revert Changes
                              </Button>
            )}
            <Button size="sm" variant="outline" onClick={onAutoRecutDialog}><FiZap />Auto Re-Cut
                          </Button>
            {isDirty ? (
              <Button
                size="sm"
                colorPalette="brand"
                onClick={onSaveUpdatedTurfs}
                loading={isSaving}><FiSave />Save Changes
                              </Button>
            ) : (
              <Button size="sm" variant="outline" onClick={onAcceptAsIs} loading={isSaving}><FiCheck />Accept As-Is
                              </Button>
            )}
          </>
        )}

        {mode === 'auto-preview' && (
          <>
            <Button size="sm" variant="outline" onClick={onRevert}><FiRotateCcw />Revert to Original
                          </Button>
            <Button size="sm" colorPalette="green" onClick={onAcceptRecut} loading={isSaving}>{isLastStep ? <FiCheck /> : <FiArrowRight />}{isLastStep ? 'Accept & Finish' : 'Accept & Next'}</Button>
          </>
        )}
      </HStack>
    </HStack>
  );
}
